module.exports = __webpack_public_path__ + "static/assets/9de7e20462ee8f25c236dca0172dbc52.png";